module.exports = __webpack_public_path__ + "static/media/Mike,47@2x.2dd5f82d.png";